import { NavLink } from 'react-router-dom';
import { DatabaseZapIcon, Home, LucideDock,  Settings } from 'lucide-react';

const SidebarLoinMagasin = () => {

  return (
    <aside className="magasin-loin-sidebar p-3 collapsed">
      <div>
      <ul className="nav flex-column mt-4">
        <li className="nav-item position-relative">
          <NavLink to="/loinmagasin/" end className="nav-link text-white d-flex align-items-center"> 
            <Home className='me-2 swing-icon'/>
            <span className="sidebar-hover-label">Home</span>
           </NavLink>
        </li>
        <li className="nav-item position-relative">
          <NavLink to="/loinmagasin/autres" end className="nav-link text-white"> 
            <LucideDock className='me-2 swing-icon'/>
            <span className="sidebar-hover-label">Bordereaux</span>
           </NavLink>
        </li>
        <li className="nav-item position-relative">
          <NavLink to="/loinmagasin/autres" className="nav-link text-white"> 
            <DatabaseZapIcon className='me-2 swing-icon'/>
            <span className="sidebar-hover-label">Utilisateurs</span>
          </NavLink>
        </li>
        <li className="nav-item position-relative">
          <NavLink to="/loinmagasin/autres" className="nav-link text-white">
          <Settings className='me-2 swing-icon'/>
          <span className="sidebar-hover-label">Gestion</span>
          </NavLink>
        </li>
        
      </ul>
      </div>
    </aside>
  );
};

export default SidebarLoinMagasin;
